import axios from 'axios';

import { apiSiblingUrl } from './client';

/*
 * Runtime auth discovery: the backend validates the tokens, so it also
 * says how to get one. GET /api/auth-config is public and CORS-open
 * (it is called before login) and answers e.g.
 *
 *   { "method": "oidc", "authority": "https://login…/realms/…" }
 *   { "method": "fake-jwt", "tokenUrl": "/fake-jwt/token" }
 *
 * Only `method` is guaranteed; unknown extra fields are ignored.
 */

/* null = no usable answer (no such endpoint, backend down, malformed)
   — the caller then falls back to the env-based selection. The mock
   mode has no backend to ask. */
export const fetchAuthConfig = async () => {
  if (process.env.REACT_APP_MOCK_API === 'true') return null;
  if (!process.env.REACT_APP_API_BASE_URL?.trim()) return null;

  try {
    /* the app shows nothing until this resolves — fail over quickly */
    const { data } = await axios.get(apiSiblingUrl('/auth-config'), {
      timeout: 3000,
    });
    return typeof data?.method === 'string' ? data : null;
  } catch {
    return null;
  }
};

/* a reported tokenUrl is relative to the backend, not to the page */
export const resolveAgainstApi = (url) =>
  new URL(url, process.env.REACT_APP_API_BASE_URL).href;
